import Model from '@/Models/Contracts/Model';
import Budget from '@/Models/Budget';
/**
 * @property {string} id
 * @property {string} name
 * @property {number} number
 * @property {string} address
 * @property {number} postcode
 * @property {string} city
 * @property {string} country
 * @property {string} phone
 * @property {boolean} has_delivery
 */
export default class Store extends Model {
    constructor() {
        super(...arguments);
        this.assignment = null;
    }
    resource() {
        return 'stores';
    }
    relations() {
        return {
            budgets: Budget,
        };
    }
    relationships() {
        return {
            budgets: this.hasMany(Budget),
        };
    }
}
